module.exports = __webpack_public_path__ + "img/potencia_r_b.b7e4812f.svg";